// extracted by mini-css-extract-plugin
export default {"modal":"NewBankAccount_modal__SM0i6"};